import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import reportWebVitals from "./reportWebVitals";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme";
import store from "./redux";
import CssBaseline from "@mui/material/CssBaseline";
import { ApiProvider } from "@reduxjs/toolkit/dist/query/react";
import { api } from "./api/apiSlice";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <ApiProvider api={api}>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
      </ThemeProvider>
    </Provider>
  </ApiProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
